/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Faqs_TitleInputs */

const en_dashboard_faqs_title = /** @type {(inputs: Dashboard_Faqs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ’s`)
};

const fr_dashboard_faqs_title = /** @type {(inputs: Dashboard_Faqs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQs`)
};

/**
* | output |
* | --- |
* | "FAQ’s" |
*
* @param {Dashboard_Faqs_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const dashboard_faqs_title = /** @type {((inputs?: Dashboard_Faqs_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Faqs_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_faqs_title(inputs)
	return fr_dashboard_faqs_title(inputs)
});